import script from "./MouseArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./MouseArea.vue?vue&type=script&setup=true&lang=ts"

import "./MouseArea.vue?vue&type=style&index=0&id=111cf836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111cf836"]])

export default __exports__